// @flow

import * as React from 'react';

import { selectCountryList } from '@gandi/redux-places';
import { Select } from '@gandi/ui-select';

import { withRouter } from 'src/helpers/withRouter';
import { useAppSelector } from 'src/hooks/useAppSelector';

import type { Option } from '../../../modules/app/selectors/locale';

type Props = {
  onChange: (option: Option) => void,
  disabled?: boolean,
  loading?: boolean,
  value: string,
  name: string,
  readOnly?: boolean,
};

function CountrySelect({
  onChange,
  disabled,
  loading,
  value,
  name,
  readOnly,
}: Props): React.MixedElement {
  const countryList = useAppSelector(selectCountryList);

  const options = countryList.map(country => ({
    label: country.name,
    value: country.alpha2,
  }));

  const selectedOption = options.find(opt => opt.value === value);
  const isDisabled = disabled || loading;
  return (
    <Select
      name={name}
      options={options}
      value={selectedOption}
      onChange={onChange}
      isLoading={loading}
      isDisabled={isDisabled}
      isReadonly={!isDisabled && (options.length <= 1 || readOnly)}
    />
  );
}

export default (withRouter(CountrySelect): React.ComponentType<Props>);
